"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-details-header.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-details-header.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigAmountTypeToJSON = exports.bigAmountTypeFromJSON = exports.Notice = exports.BigAmount = exports.ActivityDetailsHeader = exports.BigAmountType = void 0;
const amount_1 = require("../common/amount");
const icon_1 = require("./icon");
const string_1 = require("./string");
const protobufPackage = 'com.step.txactivity.proto';
var BigAmountType;
(function (BigAmountType) {
    BigAmountType["INVALID_TYPE"] = "INVALID_TYPE";
    /**
     * POSITIVE - Green. Generally for credits.
     */
    BigAmountType["POSITIVE"] = "POSITIVE";
    /**
     * PRIMARY - White. Generally for debits.
     */
    BigAmountType["PRIMARY"] = "PRIMARY";
    /**
     * DISABLED - Grayed out. Generally for declined transactions.
     */
    BigAmountType["DISABLED"] = "DISABLED";
    BigAmountType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BigAmountType || (exports.BigAmountType = BigAmountType = {}));
function createBaseActivityDetailsHeader() {
    return {
        icon: undefined,
        title: string_1.StyledString.fromPartial({}),
        subtitle: undefined,
        status: undefined,
        amount: exports.BigAmount.fromPartial({}),
        amountSubtitle: undefined,
        notices: [],
    };
}
exports.ActivityDetailsHeader = {
    fromJSON(object) {
        const message = {
            title: isSet(object.title)
                ? string_1.StyledString.fromJSON(object.title)
                : string_1.StyledString.fromPartial({}),
            amount: isSet(object.amount) ? exports.BigAmount.fromJSON(object.amount) : exports.BigAmount.fromPartial({}),
            notices: globalThis.Array.isArray(object?.notices)
                ? object.notices.map((e) => exports.Notice.fromJSON(e))
                : [],
        };
        if (isSet(object.icon)) {
            message.icon = icon_1.IconDescriptor.fromJSON(object.icon);
        }
        if (isSet(object.subtitle)) {
            message.subtitle = string_1.StyledString.fromJSON(object.subtitle);
        }
        if (isSet(object.status)) {
            message.status = string_1.StyledString.fromJSON(object.status);
        }
        if (isSet(object.amountSubtitle)) {
            message.amountSubtitle = string_1.StyledString.fromJSON(object.amountSubtitle);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.icon !== undefined) {
            obj.icon = icon_1.IconDescriptor.toJSON(message.icon);
        }
        if (message.title !== undefined) {
            obj.title = string_1.StyledString.toJSON(message.title);
        }
        if (message.subtitle !== undefined) {
            obj.subtitle = string_1.StyledString.toJSON(message.subtitle);
        }
        if (message.status !== undefined) {
            obj.status = string_1.StyledString.toJSON(message.status);
        }
        if (message.amount !== undefined) {
            obj.amount = exports.BigAmount.toJSON(message.amount);
        }
        if (message.amountSubtitle !== undefined) {
            obj.amountSubtitle = string_1.StyledString.toJSON(message.amountSubtitle);
        }
        if (message.notices?.length) {
            obj.notices = message.notices.map((e) => exports.Notice.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ActivityDetailsHeader.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityDetailsHeader();
        message.icon = (object.icon !== undefined && object.icon !== null)
            ? icon_1.IconDescriptor.fromPartial(object.icon)
            : undefined;
        message.title = (object.title !== undefined && object.title !== null)
            ? string_1.StyledString.fromPartial(object.title)
            : string_1.StyledString.fromPartial({});
        message.subtitle = (object.subtitle !== undefined && object.subtitle !== null)
            ? string_1.StyledString.fromPartial(object.subtitle)
            : undefined;
        message.status = (object.status !== undefined && object.status !== null)
            ? string_1.StyledString.fromPartial(object.status)
            : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? exports.BigAmount.fromPartial(object.amount)
            : exports.BigAmount.fromPartial({});
        message.amountSubtitle = (object.amountSubtitle !== undefined && object.amountSubtitle !== null)
            ? string_1.StyledString.fromPartial(object.amountSubtitle)
            : undefined;
        message.notices = object.notices?.map((e) => exports.Notice.fromPartial(e)) || [];
        return message;
    },
};
function createBaseBigAmount() {
    return { amount: amount_1.Amount.fromPartial({}), type: BigAmountType.INVALID_TYPE };
}
exports.BigAmount = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            type: isSet(object.type) ? bigAmountTypeFromJSON(object.type) : BigAmountType.INVALID_TYPE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.type !== BigAmountType.INVALID_TYPE) {
            obj.type = bigAmountTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.BigAmount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBigAmount();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.type = object.type ?? BigAmountType.INVALID_TYPE;
        return message;
    },
};
function createBaseNotice() {
    return { icon: undefined, content: string_1.StyledString.fromPartial({}) };
}
exports.Notice = {
    fromJSON(object) {
        const message = {
            content: isSet(object.content)
                ? string_1.StyledString.fromJSON(object.content)
                : string_1.StyledString.fromPartial({}),
        };
        if (isSet(object.icon)) {
            message.icon = icon_1.IconDescriptor.fromJSON(object.icon);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.icon !== undefined) {
            obj.icon = icon_1.IconDescriptor.toJSON(message.icon);
        }
        if (message.content !== undefined) {
            obj.content = string_1.StyledString.toJSON(message.content);
        }
        return obj;
    },
    create(base) {
        return exports.Notice.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNotice();
        message.icon = (object.icon !== undefined && object.icon !== null)
            ? icon_1.IconDescriptor.fromPartial(object.icon)
            : undefined;
        message.content = (object.content !== undefined && object.content !== null)
            ? string_1.StyledString.fromPartial(object.content)
            : string_1.StyledString.fromPartial({});
        return message;
    },
};
function bigAmountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_TYPE':
            return BigAmountType.INVALID_TYPE;
        case 1:
        case 'POSITIVE':
            return BigAmountType.POSITIVE;
        case 2:
        case 'PRIMARY':
            return BigAmountType.PRIMARY;
        case 3:
        case 'DISABLED':
            return BigAmountType.DISABLED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BigAmountType.UNRECOGNIZED;
    }
}
exports.bigAmountTypeFromJSON = bigAmountTypeFromJSON;
function bigAmountTypeToJSON(object) {
    switch (object) {
        case BigAmountType.INVALID_TYPE:
            return 'INVALID_TYPE';
        case BigAmountType.POSITIVE:
            return 'POSITIVE';
        case BigAmountType.PRIMARY:
            return 'PRIMARY';
        case BigAmountType.DISABLED:
            return 'DISABLED';
        case BigAmountType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.bigAmountTypeToJSON = bigAmountTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-details-header.js.map